import { render, staticRenderFns } from "./course.vue?vue&type=template&id=313aa75e&"
import script from "./course.vue?vue&type=script&lang=ts&"
export * from "./course.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports